<!--
*****************************************************************************
*File : AppFooter.vue
*Module : Dashboard Frontend
*Purpose : Centralized footer component for the entire application
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-footer id="app-footer" :absolute="absolute" :color="color" :dark="dark">
    <v-container>
      <v-row align="center" no-gutters>
        <v-spacer class="hidden-sm-and-down" />

        <!-- Company Logos -->
        <v-col v-if="showLogos">
          <div class="pt-6 pt-md-0 pr-4 text-end">
            <a target="_blank" href="https://iisc.ac.in/" class="footer-logo">
              <img :src="iiscLogo" alt="IISc Logo" class="footer-logo-img" />
            </a>
            <a target="_blank" href="https://dfccil.com/" class="footer-logo">
              <img
                contain
                src="../assets/images/DFCCIL1.png"
                alt="DFCCIL Logo"
                class="footer-logo-img"
              />
            </a>
            <a target="_blank" href="https://l2mrail.com/" class="footer-logo">
              <img
                contain
                src="../assets/images/L2M-Logo.png"
                alt="L2M Logo"
                class="footer-logo-img"
              />
            </a>
          </div>
        </v-col>

        <!-- Copyright Text -->
        <v-col cols="12" class="text-end">
          <v-card-text class="body-1 font-weight-light pt-6 pt-md-0 pr-4 text-end">
            &copy; {{ new Date().getFullYear() }} by
            <a href="https://www.l2mrail.com" target="_blank" class="company-link">
              Lab To Market Innovations Pvt. Ltd </a
            >.
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import logoLight from '../assets/images/IISc_logo.png';
import logoDark from '../assets/images/IISc_logo_white.png';

export default {
  name: 'AppFooter',

  props: {
    showLogos: {
      type: Boolean,
      default: true,
    },
    absolute: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'transparent',
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iiscLogo() {
      return this.dark ? logoDark : logoLight;
    },
  },
};
</script>

<style lang="scss" scoped>
#app-footer {
  .footer-logo {
    display: inline-block;
    margin-left: 4%;

    &:first-child {
      margin-left: 0;
    }
  }

  .footer-logo-img {
    object-fit: contain;
    width: 100px;
    height: 60px;

    &[alt='DFCCIL Logo'],
    &[alt='L2M Logo'] {
      height: 50px;
    }
  }

  .company-link {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

// Global styles for footer links
:deep(a) {
  color: #3c4858;
  font-size: 0.825rem;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    text-decoration: underline;
  }
}

// Dark theme adjustments
.theme--dark #app-footer {
  :deep(a) {
    color: #ffffff;
  }
}
</style>
